import { Component, inject, OnInit } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import {
  CategoryItem,
  CategorySelectorComponent,
} from '../../../custom-input/category-selector/category-selector.component';
import { AccommodationFormService } from 'src/app/trip-calculator/services/accommodation-form.service';
import { AccommodationType } from 'src/app/trip-calculator/models/accommodation';

@Component({
  selector: 'app-select-accommodation-type',
  imports: [TranslocoPipe, CategorySelectorComponent],
  templateUrl: './select-accommodation-type.component.html',
})
export class SelectAccommodationTypeComponent implements OnInit {
  accommodationFormService = inject(AccommodationFormService);
  translocoService = inject(TranslocoService);
  typeList: CategoryItem[] = [];

  ngOnInit() {
    this.initializeTypeList();
  }

  initializeTypeList() {
    this.typeList = [];
    for (const type of Object.values(AccommodationType)) {
      if (
        type === AccommodationType.CustomFactor &&
        !this.accommodationFormService.hasCustomFactor
      ) {
        continue;
      }
      this.typeList.push({
        value: type,
        label: this.translocoService.translate('categoryType.' + type),
      });
    }
  }

  get type() {
    const type =
      this.accommodationFormService.accommodationForm.get('type')?.value;
    return type ? type : '';
  }

  set type(value) {
    this.accommodationFormService.accommodationForm
      .get('type')
      ?.setValue(value);
  }
}
